<script>
import { IDENTITY_SERVER_URL } from '@/config'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('user', [
      'organization',
      'profile',
      'isInRole',
      'isAuthenticated',
      'isSysAdmin',
      'isOrgAdmin',
      'userId'
    ]),
    profileLink() {
      return `${IDENTITY_SERVER_URL}/manage/index`
    }
  }
}
</script>
